import React from 'react';
import { Row, Col, Form, Button, Card } from 'react-bootstrap';
import ConditionRow from '../../common/ConditionRow';
import { standardInputStyles, standardLabelStyles } from '../../../utils/conditionInputStyles';

/**
 * Sharing-rule criteria: same field / operator / value UX as workflow criteria,
 * without "Evaluate On" or isChanged (sharing applies to record visibility, not create/update events).
 */
export default function SharingRuleCriteriaConfig({
  criteriaList,
  onAdd,
  onDelete,
  onChange,
  objectFields,
  readOnly,
  disabled = false,
}) {
  const operators = [
    { value: '=', label: '=' },
    { value: '!=', label: '!=' },
    { value: '<', label: '<' },
    { value: '>', label: '>' },
    { value: '<=', label: '<=' },
    { value: '>=', label: '>=' },
    { value: 'IN', label: 'IN' },
    { value: 'NOT IN', label: 'NOT IN' },
    { value: 'contains', label: 'Contains' },
    { value: 'starts_with', label: 'Starts With' },
    { value: 'ends_with', label: 'Ends With' },
  ];

  const picklistOperators = [
    { value: '=', label: '=' },
    { value: '!=', label: '!=' },
    { value: 'IN', label: 'IN' },
    { value: 'NOT IN', label: 'NOT IN' },
  ];

  return (
    <div className="mt-2">
      {criteriaList != null &&
        criteriaList.length > 0 &&
        criteriaList.map((criteria, index) => (
          <Card key={index} className="mb-3 border">
            <Card.Body className="p-3">
              <Row className="align-items-end">
                <Col md={10}>
                  <ConditionRow
                    condition={criteria}
                    fields={objectFields}
                    onChange={onChange}
                    index={index}
                    readOnly={readOnly}
                    options={{
                      fieldKey: 'fieldName',
                      nameKey: 'field_name',
                      labelKey: 'field_label',
                      customOperators: operators,
                      picklistOperators,
                      fieldColSize: 4,
                      operatorColSize: 3,
                      valueColSize: 5,
                    }}
                  />
                </Col>
                {!readOnly && (
                  <Col md={2} className="d-flex align-items-end pb-3">
                    <Button
                      variant="outline-danger"
                      onClick={() => onDelete(index)}
                      size="sm"
                      disabled={readOnly}
                      className="w-100"
                    >
                      Delete
                    </Button>
                  </Col>
                )}
              </Row>
            </Card.Body>
          </Card>
        ))}

      {criteriaList == null || criteriaList.length === 0 ? (
        <div className="text-center py-3 text-muted border rounded bg-light">
          <p className="mb-0 small">No criteria yet. Add criteria to limit which records this rule applies to.</p>
        </div>
      ) : null}

      {!readOnly && (
        <Button
          variant="outline-primary"
          onClick={onAdd}
          disabled={readOnly || disabled}
          title={disabled ? 'Select an object first' : ''}
          className="mt-2"
          size="sm"
        >
          <i className="fa fa-plus me-2" />
          Add Criteria
        </Button>
      )}
    </div>
  );
}

/** Criteria logic: combine builder rows with AND/OR, or use a custom expression only. */
export function SharingCriteriaLogicSelect({ value, onChange, readOnly }) {
  const normalized = ['AND', 'OR', 'CUSTOM'].includes(value) ? value : 'AND';
  return (
    <Form.Group className="mb-3">
      <Form.Label className="fw-semibold" style={standardLabelStyles}>
        Criteria Logic
      </Form.Label>
      <Form.Select
        value={normalized}
        onChange={(e) => onChange(e.target.value)}
        disabled={readOnly}
        style={standardInputStyles}
      >
        <option value="AND">AND (All Rows Must Match)</option>
        <option value="OR">OR (Any Row Can Match)</option>
        <option value="CUSTOM">Custom Logic (Expression)</option>
      </Form.Select>
    </Form.Group>
  );
}
